/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface TaskStatusDto
 */
export interface TaskStatusDto {
    /**
     * Stable identifier of the task type
     * @type {string}
     * @memberof TaskStatusDto
     */
    id: string;
    /**
     * Human readable name of the task type
     * @type {string}
     * @memberof TaskStatusDto
     */
    name: string;
    /**
     * State of the latest run of the task
     * @type {string}
     * @memberof TaskStatusDto
     */
    state: TaskStatusDtoStateEnum;
    /**
     * UTC time when the latest run started, null if the task has not been started yet
     * @type {Date}
     * @memberof TaskStatusDto
     */
    startedAt?: Date;
    /**
     * UTC time when the latest run finished, null if it has not finished yet
     * @type {Date}
     * @memberof TaskStatusDto
     */
    finishedAt?: Date;
    /**
     * Number of items processed by the latest run
     * @type {number}
     * @memberof TaskStatusDto
     */
    processedCount?: number;
    /**
     * Number of items to be processed by the latest run, 0 if unknown
     * @type {number}
     * @memberof TaskStatusDto
     */
    totalCount?: number;
    /**
     * Task specific details of the latest run, e.g. the rulesets of a ruleset replacement
     * @type {{ [key: string]: string; }}
     * @memberof TaskStatusDto
     */
    attributes: { [key: string]: string; };
    /**
     * Reason of the failure if the latest run failed, null otherwise
     * @type {string}
     * @memberof TaskStatusDto
     */
    failureMessage?: string;
}


/**
 * @export
 */
export const TaskStatusDtoStateEnum = {
    NotStarted: 'NOT_STARTED',
    InProgress: 'IN_PROGRESS',
    Completed: 'COMPLETED',
    Failed: 'FAILED'
} as const;
export type TaskStatusDtoStateEnum = typeof TaskStatusDtoStateEnum[keyof typeof TaskStatusDtoStateEnum];


/**
 * Check if a given object implements the TaskStatusDto interface.
 */
export function instanceOfTaskStatusDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "state" in value;
    isInstance = isInstance && "attributes" in value;

    return isInstance;
}

export function TaskStatusDtoFromJSON(json: any): TaskStatusDto {
    return TaskStatusDtoFromJSONTyped(json, false);
}

export function TaskStatusDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskStatusDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'state': json['state'],
        'startedAt': !exists(json, 'startedAt') ? undefined : (new Date(json['startedAt'])),
        'finishedAt': !exists(json, 'finishedAt') ? undefined : (new Date(json['finishedAt'])),
        'processedCount': !exists(json, 'processedCount') ? undefined : json['processedCount'],
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'attributes': json['attributes'],
        'failureMessage': !exists(json, 'failureMessage') ? undefined : json['failureMessage'],
    };
}

export function TaskStatusDtoToJSON(value?: TaskStatusDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'state': value.state,
        'startedAt': value.startedAt === undefined ? undefined : (value.startedAt.toISOString()),
        'finishedAt': value.finishedAt === undefined ? undefined : (value.finishedAt.toISOString()),
        'processedCount': value.processedCount,
        'totalCount': value.totalCount,
        'attributes': value.attributes,
        'failureMessage': value.failureMessage,
    };
}

